import Shipping from '../../src/legacy/Shipping';
export default Shipping;
